import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP015_Request,
  IAPI_APP015_Response,
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// グループ申請情報参照
const httpAPI_APP015 = async (
  param: IAPI_APP015_Request
): Promise<IAPI_APP015_Response> => {
  let res = await http.post(ApiUrl.API_APP015, {
    ...param,
  });

  return res.data;
};

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_APP015, httpAPI_APP016 };
